export default __webpack_public_path__ + "static/media/avatar4.cb17f69e.svg";